import React, { useState } from 'react';
import { X, AlertTriangle, Loader } from 'lucide-react';

const AcknowledgeClaimModal = ({ claim, onConfirm, onClose, loading }) => {
  const [justification, setJustification] = useState('');
  const charCount = justification.trim().length;
  const isValid = charCount >= 50;

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-2xl max-w-md w-full border border-gray-200">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
            <h3 className="text-lg font-semibold text-gray-900">Acknowledge Risk</h3>
          </div>
          <button onClick={onClose} disabled={loading} className="p-1 hover:bg-gray-100 rounded">
            <X className="w-5 h-5 text-gray-400" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <p className="text-sm text-amber-800 font-medium mb-1">Unverified Claim</p>
            <p className="text-sm text-amber-700">{claim?.claim_text}</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Justification <span className="text-red-500">*</span>
            </label>
            <p className="text-xs text-gray-500 mb-2">
              Explain why this claim is acceptable without verification (minimum 50 characters).
            </p>
            <textarea
              value={justification}
              onChange={(e) => setJustification(e.target.value)}
              placeholder="Provide a justification for acknowledging this unverified claim..."
              className="w-full h-32 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500 resize-none"
              disabled={loading}
            />
            <p className={`text-xs mt-1 ${charCount >= 50 ? 'text-green-600' : 'text-gray-400'}`}>
              {charCount}/50 characters minimum
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-100">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(justification.trim())}
            disabled={!isValid || loading}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-amber-600 rounded-lg hover:bg-amber-700 disabled:opacity-50"
          >
            {loading ? <Loader className="w-4 h-4 animate-spin" /> : <AlertTriangle className="w-4 h-4" />}
            Acknowledge Risk
          </button>
        </div>
      </div>
    </div>
  );
};

export default AcknowledgeClaimModal;
